import { z } from 'zod'

// Zod probes for `new Function` to compile faster validators, at module load of the first object
// schema. Our CSP forbids eval, so in the browser the probe is reported as a violation on every
// page even though Zod copes. Skip it. Import this module before anything that builds schemas;
// it is listed in `sideEffects` in package.json so the bundler keeps the bare import.
// (the redaction worker counts as the browser too)
if (typeof window !== 'undefined' || 'WorkerGlobalScope' in globalThis) {
  z.config({ jitless: true })
}
